import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppService } from '../../app.service';
// import { AlertsService } from '../../shared/component/alerts/alerts.service';
import { TermsAndConditionService } from '../terms-and-condition/terms-and-condition.service';
import { ENDPOINTS, ORG_DETAILS } from '../../app.config';
// import { LocalStorageService } from '../../auth-services/local-storage.service';
// import { AuthTokenService } from '../../auth-services/auth-token.service';

@Component({
  selector: 'app-terms-and-condition',
  templateUrl: './terms-and-condition.component.html'
})
export class TermsAndConditionComponent implements OnInit {

  // showContent:any = [];

  data:any = []

  content : any;

  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };

  // data = [{title:"terms",content:"This is title"},{title:"condition",content:"this is condition"}]

  showContent:any = []
  constructor(
    private router: Router,
    private termsAndConditionService: TermsAndConditionService,
    private appService: AppService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    // private alertService: AlertsService,
    private activatedRoute: ActivatedRoute,
    // private localService: LocalStorageService,
    // private authTokenService: AuthTokenService
  ) { }

  ngOnInit(): void {
    this.showContent=[false,false,false]

    window.scrollTo(0,0)
    this.getTermsAndCondition()
  }

  show1(e:any){
    console.log(e)
    if(this.showContent[e]===true){
      this.showContent[e]=false;
    }else{
      this.showContent[e]=true;
    }
    console.log(this.showContent[e])
  }

  show(e:any){
    console.log(e)
    e = e.target.id
    if(this.showContent[e]===true){
      this.showContent[e]=false;
    }else{
      this.showContent[e]=true;
    }
    console.log(this.showContent[e])
  }

  getTermsAndCondition() {
    let requestBody = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {

        },
        "pagination": true,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 10
        },
        "sorting": true,
        "sortingDetails": {
          "email": -1
        }
      }
    }
    // MAKE A SERVICE CALL HERE...
    this.appService.postApiCall(requestBody, ENDPOINTS.GET_ALL_TERMS_AND_CONDITION).subscribe(
      resp => {
        if (resp.result.data[0].length !== 0) {
          this.data = resp.result.data[0]
          console.log(this.data)
          this.content = this.data.content;
          document.getElementById('terms-content').innerHTML = this.content;
        }
      },
      err => {
        if (err.error.statusCode === 403) {
          // this.alertService.error('Session Time Out! Please login Again', this.options)
          this.router.navigate([`/login-new`], { skipLocationChange: false });
        }
        // else if (err.error.message) {
        //   this.alertService.error(err.error.message, this.options)
        // }
        // else {
        //   this.alertService.error('Something bad happened. Please try again!', this.options);
        // }
      }
    )
  }


}
